module.exports = __webpack_public_path__ + "img/closeabacus.b04cac37.svg";